
<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <b-card>
        <div class="p-5">
          <h2>{{ confirm }}</h2>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { Validator } from "vee-validate";

export default {
  data() {
    return {
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      id: 0,
      status: 0,
    };
  },

  mounted() {
    let enc = this.$route.params.status;
    let decode = window.atob(enc);

    let [appointment_id, status] = decode.split("&");
    this.loadLocale(this.$i18n.locale);
    this.status = parseInt(status);
    this.id = parseInt(appointment_id);
    this.updateStatus();
  },

  computed: {
    confirm() {
      let accept = this.$t("ThankYouReschedule");
      let reject = this.$t("ThankYouReject");
      if (this.status) return accept;
      return reject;
    },
  },
  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.loadLocale(value);
      },
    },
  },
  methods: {
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },

    updateStatus() {
      this.success = "";
      this.error = "";
      this.show = true;
      let data = {
        is_status: this.status,
        appointment_id: this.id,
      };

      this.$store
        .dispatch("GetStatus", data)
        .then((res) => {
          //   this.show=false;
          this.show = false;
        })
        .catch((error) => {
          this.$log.error(
            "File : status.vue | Function : updateStatus() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>

<style>
.vs-input--label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
}
#update {
  display: inline-flex;
}

#cancel {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
}

.message {
  margin-top: 20px;
}

.switch {
  margin-top: 20px;
}

.contact_number {
  padding: 8px !important;
}

#contact_label {
  margin-top: 15px;
}
.company-form {
  font-family: inherit;
}
.flatpick {
  padding: 5px !important;
}
</style>